import { createAccessControl } from 'better-auth/plugins/access';
import { defaultStatements, adminAc } from 'better-auth/plugins/admin/access';

/**
 * Define custom statements (resources and their actions)
 * Merge with defaultStatements to keep built-in admin permissions
 */
export const statement = {
  ...defaultStatements,
  // Add custom resources here if needed
  // project: ['create', 'read', 'update', 'delete'],
} as const;

export const ac = createAccessControl(statement);

/**
 * Superadmin role - has all admin permissions (same as built-in admin)
 */
export const superadmin = ac.newRole({
  user: adminAc.statements.user,
  session: adminAc.statements.session,
});

/**
 * Regular user role - no admin permissions
 */
export const user = ac.newRole({
  user: [],
  session: [],
});
